import React from 'react';

const StatusBadge = ({ status }) => {
  const label =
    status == null || status === ''
      ? '—'
      : String(status).replaceAll('_', ' ');
  return (
    <span className="badge rounded-pill shadow-sm fw-semibold bg-light text-muted text-capitalize">
      {label}
    </span>
  );
};

export default StatusBadge;
